export const mutations = {
  setState(state, payload) {
    Object.keys(payload).forEach((key) => {
      if (key in state) {
        state[key] = payload[key]
      }
    })
  }
}

export const actions = {
  fetchSettings(_, params) {
    return this.$api
      .get("/sitesettings/get", { params })
      .then((res) => {
        return res && res.data
      })
      .catch((err) => {
        console.error(err)
      })
  },

  submitSettings(_, payload) {
    return this.$api.put("/sitesettings/update", payload)
  }
}
